import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { CircularProgress, Fade } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { validateSignInData } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import { Redirect, withRouter } from 'react-router-dom';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import SocialSignin from '../../components/Social/SocialSignin';
import { cookies } from '../../utils/getToken';
import { FormattedMessage, injectIntl } from 'react-intl';

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            showCustomerVerification: false,
            showProviderVerification: false,
            closeVerification: false,
            playerId: '',
            showForgotPopup: false,
            samePage: false,
            role: '',
            customerRedirect: false,
            providerRedirect: false
        };
        this.props = {
            renderSamePage: props.renderSamePage ? props.renderSamePage : false,
            renderUrl: props.renderUrl
        };
    }

    handleClose = () => {
        this.props.closeLoginPopup();
    };

    renderLoginButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.loginActionCall()}
                >
                    <FormattedMessage id="login" defaultMessage="Login" />
                </Button>
            );
        }
    };

    loginActionCall = () => {
        if (
            validateSignInData(
                { email: this.state.email, password: this.state.password },
                this.handleError
            )
        ) {
            this.setState({ loaderButton: true });
            this.props.loginAction(
                {
                    email: this.state.email,
                    password: this.state.password
                },
                this.onDone
            );
        } else {
            NotificationManager.error('Validation Error', 'Oops!');
        }
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        this.setState({
            role: data.role
        });

        if (success == 'NOV') {
            if (data.data.role == ROLE_CUSTOMER) {
                this.setState(
                    {
                        loaderButton: false
                    },
                    () => {
                        this.props.renderCustomerVerification(this.state.email);
                        this.handleClose();
                    }
                );
            } else if (data.data.role == ROLE_PROVIDER) {
                this.setState(
                    {
                        loaderButton: false,
                        showProviderVerification: true
                    },
                    () => {
                        this.props.renderProviderVerification(this.state.email);
                        this.handleClose();
                    }
                );
            }
        } else if (success == true) {
            if (!cookies.get('x-auth-token', { path: '/' })) {
                cookies.set('x-auth-token', data.token, { path: '/' });
            }
            if (!this.props.renderSamePage) {
                if (this.state.role == ROLE_CUSTOMER) {
                    this.setState({
                        loaderButton: false,
                        customerRedirect: true
                    });
                } else {
                    this.setState({
                        loaderButton: false,
                        providerRedirect: true
                    });
                }
            } else {
                this.setState({
                    loaderButton: false,
                    samePage: true
                });
            }
        } else {
            this.setState({
                loaderButton: false,
                emailError: data.message
            });
        }
    };
    handleClose = () => {
        this.props.closeLoginPopup();
    };
    render() {
        const { passwordError, emailError } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.customerRedirect) {
            this.props.history.push(`/user/profile`);
            // return <Redirect to={'/user/profile'} />;
        }
        if (this.state.providerRedirect) {
            this.props.history.push({ pathname: `/user/dashboard` });
        }
        if (this.state.samePage) {
            this.props.history.push({ pathname: this.props.renderUrl });
            // return <Redirect to={this.props.renderUrl} />;
        }
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    className="text-center"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <form
                        className="dialog-form dialog-form-new"
                        autoComplete="off"
                    >
                        <div
                            className="dialog-header"
                            style={{
                                backgroundColor: this.props.theme.palette
                                    .primary.main
                            }}
                        >
                            <h3 className="dialog-heading">
                                <FormattedMessage
                                    id="login"
                                    defaultMessage="Login"
                                />
                            </h3>

                            <SocialSignin
                                loginDone={this.handleClose}
                                isLoginScreenCall={true}
                                class="light"
                            />
                        </div>
                        <div className="dialog-body">
                            <DialogContent>
                                <TextField
                                    error={emailError ? true : false}
                                    helperText={emailError}
                                    className="login-form-textfield"
                                    id="email"
                                    fullWidth={true}
                                    name="email"
                                    placeholder={formatMessage({
                                        id: 'email'
                                    })}
                                    type="email"
                                    value={this.state.email}
                                    onChange={event => {
                                        this.setState({
                                            email: event.target.value,
                                            emailError: ''
                                        });
                                    }}
                                    disabled={this.state.loaderButton}
                                    margin={'normal'}
                                    title="Enter your email"
                                />
                                <TextField
                                    error={passwordError ? true : false}
                                    helperText={passwordError}
                                    className="login-form-textfield"
                                    id="password"
                                    fullWidth={true}
                                    name="password"
                                    type="password"
                                    placeholder={formatMessage({
                                        id: 'password'
                                    })}
                                    value={this.state.password}
                                    onChange={event => {
                                        this.setState({
                                            password: event.target.value,
                                            passwordError: ''
                                        });
                                    }}
                                    disabled={this.state.loaderButton}
                                    margin={'normal'}
                                    title="Enter your password"
                                />

                                <p>
                                    <a
                                        style={{
                                            cursor: 'pointer',
                                            color: this.props.theme.palette
                                                .primary.main
                                        }}
                                        onClick={() =>
                                            this.props.renderForgotPassword(
                                                this.state.email
                                            )
                                        }
                                    >
                                        <FormattedMessage
                                            id="forgotPassword"
                                            defaultMessage="Forgot Password?"
                                        />
                                    </a>
                                </p>
                            </DialogContent>

                            <DialogActions>
                                <div className="col-md-12 log-btn text-center">
                                    {this.renderLoginButton()}
                                </div>
                            </DialogActions>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(null, actions)
);
export default composedHOC(withRouter(injectIntl(LoginForm)));



// WEBPACK FOOTER //
// ./src/views/LoginPage/LoginForm.jsx